import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import {
  Input,
  Button,
  Popup,
  Form
} from 'semantic-ui-react'

const stringToNum = R.compose(
  R.defaultTo(0),
  parseInt
)
// const numToString = R.tryCatch(String, R.always(''))

const onNumberChange = (name, value, onChange) => (e, data) => {
  e.preventDefault()
  onChange(e, {name, value})
}

const NumberButtons = ({
  disabled = false,
  onChange,
  name,
  value
}) => (
  <React.Fragment>
    <Button disabled={ disabled } compact color='grey' icon='plus' onClick={ onNumberChange(name, stringToNum(value) + 1, onChange) } />
    <Button disabled={ disabled } compact color='grey' icon='minus' onClick={ onNumberChange(name, stringToNum(value) - 1, onChange) } />
  </React.Fragment>
)
NumberButtons.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
}

const NumberInput = ({
  name,
  width,
  value,
  onChange,
  placeholder,
  popupTxt,
  labelTxt,
  min = null,
  max = null,
  readOnly = false
}) => {
  const clampValue = (number) => {
    return R.clamp(
      min || -Infinity,
      max || Infinity,
      number
    );
  };

  const onChangeSetNumeric = (name) => (e, data) => {
    onChange(e, {
      name,
      value: clampValue(stringToNum(data.value)),
    });
  };

  const val = R.clamp(
    R.isNil(min) ? -Infinity : min,
    R.isNil(max) ? Infinity : max,
    stringToNum(value)
  )

  const onKey = (name, onChange) => {
    if (readOnly) return;
    R.cond([
      // need to capture the Enter key and set the value, otherwise it somehow gets captured by the first input and increases
      // the value
      [R.propEq('key', 'Enter'), (e) => {
        e.preventDefault();
        onChange(e, { name, value: clampValue(stringToNum(e.target.value)) });
      }],
      [R.propEq('key', 'ArrowUp'), (e) => {
        e.preventDefault();
        onChange(e, { name, value: clampValue(stringToNum(e.target.value) + 1) });
      }],
      [R.propEq('key', 'ArrowDown'), (e) => {
        e.preventDefault();
        onChange(e, { name, value: clampValue(stringToNum(e.target.value) - 1) });
      }],
      [R.T, R.always(false)]
    ]);
  }

  return (
    <Form.Field width={R.isNil(width) ? null : width}>
      <Popup
        trigger={<label>{labelTxt}</label>}
        content={popupTxt}
      />
      <Input
        type='text'
        pattern='[0-9.]*'
        name={name}
        onChange ={onChangeSetNumeric(name)}
        value={val}
        placeholder={placeholder || null}
        autoComplete='off'
        onFocus={(e) => e.target.select()}
        onKeyDown={onKey(name, onChange)}
        action={<NumberButtons disabled={ readOnly } name={name} onChange={onChange} value={val} />}
        readOnly={ readOnly }
      />
    </Form.Field>
  )
};

NumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  labelTxt: PropTypes.string,
  popupTxt: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  width: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};

export default NumberInput;



// WEBPACK FOOTER //
// ./webAdmin/forms/baseNumber.js